<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        x-small
        label
        outlined
        color="primary"
        class="ranked-chip font-weight-bold"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left x-small>mdi-chart-line</v-icon>
        Ranked
        <span v-if="selectedRoundsCount !== null" class="ml-1">
          · {{ selectedRoundsCount }}
        </span>
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SeasonRlrRatingChip',
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    selectedRoundsCount() {
      return this.settings.roundSelection === 'specific'
        ? (this.settings.rounds || []).length
        : null
    },
    tooltip() {
      if (this.settings.roundSelection === 'specific') {
        const count = this.selectedRoundsCount
        return `${count} ${count === 1 ? 'etapă este inclusă' : 'etape sunt incluse'} în calculul RLR Rating.`
      }
      return 'Toate etapele sezonului sunt incluse în calculul RLR Rating.'
    }
  }
}
</script>

<style scoped>
.ranked-chip {
  vertical-align: middle;
}
</style>
